/**
 * Utility function to combine classes segments.
 *
 * @param segments - An array of classes segments.
 * @returns A single string combining the classes segments with " ".
 */
export function combineClasses(...segments: string[]): string {
  return segments.join(' ');
}
